import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-save-toast',
  templateUrl: './success-save-toast.component.html',
  styleUrls: ['./success-save-toast.component.css']
})
export class SuccessSaveToastComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
